import { workflowTranslation as wc } from '../workflowCompletion/workflowTranslations';

export const workflow = {
  steps: [
    {
      id: '1',
      name: wc(['createEntityWorkflow', 'stepName']),
      subSteps: [
        {
          id: '1',
          type: 'TYPE_SELECT',
          rolesCompleteableBy: [],
          options: {
            title: wc(['createEntityWorkflow', 'typeSelect', 'title']),
            options: [
              {
                value: 'INDIVIDUAL',
                label: wc(['createEntityWorkflow', 'typeSelect', 'individual']),
              },
              {
                value: 'NON_INDIVIDUAL',
                label: wc([
                  'createEntityWorkflow',
                  'typeSelect',
                  'nonIndividual',
                ]),
              },
            ],
          },
        },
        {
          id: '2',
          type: 'TYPE_SELECT',
          canGoBack: true,
          rolesCompleteableBy: [],
          options: {
            title: wc([
              'createEntityWorkflow',
              'nonIndividualTypeSelect',
              'title',
            ]),
            options: [
              {
                value: 'PUBLICLY_LISTED_ENTITY',
                label: wc([
                  'createEntityWorkflow',
                  'nonIndividualTypeSelect',
                  'publiclyListedEntity',
                ]),
              },
              {
                value: 'PRIVATE_COMPANY',
                label: wc([
                  'createEntityWorkflow',
                  'nonIndividualTypeSelect',
                  'privateCompany',
                ]),
              },
              {
                value: 'PARTNERSHIP',
                label: wc([
                  'createEntityWorkflow',
                  'nonIndividualTypeSelect',
                  'partnership',
                ]),
              },
              {
                value: 'SOLE_PROPRIETORSHIP',
                label: wc([
                  'createEntityWorkflow',
                  'nonIndividualTypeSelect',
                  'soleProprietorship',
                ]),
              },
              {
                value: 'TRUST',
                label: wc([
                  'createEntityWorkflow',
                  'nonIndividualTypeSelect',
                  'trust',
                ]),
              },
              {
                value: 'INVESTMENT_FUND',
                label: wc([
                  'createEntityWorkflow',
                  'nonIndividualTypeSelect',
                  'investmentFund',
                ]),
              },
              {
                value: 'REGULATED_ENTITY',
                label: wc([
                  'createEntityWorkflow',
                  'nonIndividualTypeSelect',
                  'regulatedEntity',
                ]),
              },
              {
                value: 'OTHER',
                label: wc([
                  'createEntityWorkflow',
                  'nonIndividualTypeSelect',
                  'other',
                ]),
              },
            ],
          },
        },
        {
          id: '3',
          type: 'SIMPLE_FORM',
          rolesCompleteableBy: [],
          canGoBack: true,
          options: {
            title: wc(['createEntityWorkflow', 'entityCreation', 'title']),
            primaryEmail: {
              required: 'ERROR',
              enabled: true,
              label: wc(['createEntityWorkflow', 'entityCreation', 'email']),
            },
            firstName: {
              required: 'ERROR',
              enabled: true,
              label: wc([
                'createEntityWorkflow',
                'entityCreation',
                'firstName',
              ]),
            },
            middleName: {
              enabled: true,
              label: wc([
                'createEntityWorkflow',
                'entityCreation',
                'middleName',
              ]),
            },
            lastName: {
              required: 'ERROR',
              enabled: true,
              label: wc(['createEntityWorkflow', 'entityCreation', 'lastName']),
            },
            entityName: {
              required: 'ERROR',
              enabled: true,
              label: wc([
                'createEntityWorkflow',
                'entityCreation',
                'entityName',
              ]),
            },
          },
        },
      ],
    },
  ],
};

export default workflow;
